/*
	A record's photo, kept as an image observation (see PictProvider-InputType-ObservationPhoto.js). The hidden input
	holds the IDObservation; the provider fills the preview and sets the button labels.
*/
const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-ObservationPhoto',
			DefaultInputExtensions: [ 'ObservationPhoto' ],
			Template: /*HTML*/`
			<!-- InputType ObservationPhoto {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					{~D:Record.Macro.InputChangeHandler~}
				/>
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<!-- dynamically filled with the photo, if the record has one -->
					<div id="PHOTO-PREVIEW-FOR-{~D:Record.Macro.RawHTMLID~}" class="mb-2 is-hidden"></div>
					<div {~D:Record.Macro.ControlAttr~} id="PHOTO-CONTROLS-FOR-{~D:Record.Macro.RawHTMLID~}" class="field is-grouped">
						<div class="control file is-link is-small">
							<label class="file-label">
								<input
									id="PHOTO-FILE-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
									class="file-input"
									type="file"
									accept="image/*"
									onchange="{~P~}.providers.ObservationPhoto.handlePhotoSelection('{~D:Record.Macro.RawHTMLID~}');"
								/>
								<span class="file-cta">
									<span class="file-icon">
										<i class="fas fa-camera" aria-hidden="true"></i>
									</span>
									<span id="PHOTO-ADD-LABEL-FOR-{~D:Record.Macro.RawHTMLID~}" class="file-label">Add photo</span>
								</span>
							</label>
						</div>
						<div class="control">
							<button id="PHOTO-REMOVE-FOR-{~D:Record.Macro.RawHTMLID~}" type="button" class="button is-small is-danger is-light is-hidden" onclick="{~P~}.providers.ObservationPhoto.handleRemovePhoto('{~D:Record.Macro.RawHTMLID~}');">
								<span class="icon">
									<i class="fas fa-trash" aria-hidden="true"></i>
								</span>
								<span>Remove photo</span>
							</button>
						</div>
					</div>
					<p id="PHOTO-STATUS-FOR-{~D:Record.Macro.RawHTMLID~}" class="help is-hidden" role="status"></p>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-ObservationPhoto',
			DefaultInputExtensions: [ 'ObservationPhoto' ],
			Template: /*HTML*/`
			<!-- InputType ObservationPhoto {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
				/>
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<!-- dynamically filled with the photo, or "No photo." -->
					<div id="PHOTO-PREVIEW-FOR-{~D:Record.Macro.RawHTMLID~}">
						<div class="input is-static has-text-text-60"><em>No photo.</em></div>
					</div>
				</div>
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;
